module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("number-card " + _vm.state + " " + (_vm.selected ? 'selected' : '')),
    on: {
      "click": function($event) {
        return _vm.goTo()
      }
    }
  }, [(_vm.tooltipIdentifier) ? _c('div', {
    staticClass: "tooltip-bottom-right"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": _vm.tooltipIdentifier
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: 'fad fa-' + _vm.icon + ' fa-fw'
  })]), _vm._v(" "), _c('div', {
    staticClass: "number",
    class: 'colo__' + _vm.state
  }, [(_vm.number !== false) ? _c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": 0,
      "endVal": Number(_vm.number),
      "duration": 5000,
      "autoplay": true,
      "separator": "."
    }
  }) : _c('span', {
    staticClass: "soon"
  }, [_vm._v("\n            Kommer snart\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee45503c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/NumberCard.vue
// module id = 942
// module chunks = 0